import React, { useState } from "react";
import { toast } from "sonner";
import { api, apiErr, shareText } from "../api";
import { Page, SectionTitle } from "../components/Layout";
import { Gift, Share2, Copy, CheckCircle2 } from "lucide-react";

const PROGRAMS = [
  { id: "trico", title: "Tricopigmentazione", reward: "Buono Amazon 100 €", desc: "Invita chi potrebbe essere interessato a un trattamento di tricopigmentazione." },
  { id: "coworking", title: "Coworking", reward: "Buono Amazon 20 €", desc: "Invita un artista a lavorare negli spazi MAS Coworking." },
];

export default function ReferralPage() {
  const [program, setProgram] = useState("");
  const [f, setF] = useState({ name: "", contact: "" });
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState(null);
  const [copied, setCopied] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const link = result ? `${window.location.origin}${result.path}` : "";

  const submit = async (e) => {
    e.preventDefault();
    if (!program) return toast.error("Scegli il tipo di invito.");
    if (!f.name.trim()) return toast.error("Inserisci il tuo nome.");
    if (!f.contact.trim()) return toast.error("Inserisci un contatto (telefono o email).");
    setBusy(true);
    try {
      const { data } = await api.post("/referral/invite", { name: f.name, contact: f.contact, program });
      setResult(data);
    } catch (er) { toast.error(apiErr(er)); } finally { setBusy(false); }
  };

  const doShare = async () => {
    const msg = `Ti invito a scoprire MAS ${result.program === "trico" ? "Tricopigmentazione" : "Coworking Studio"}: ${link}`;
    const r = await shareText("MAS · Invito", msg);
    if (r === "copied") { setCopied(true); toast.success("Link copiato"); setTimeout(() => setCopied(false), 2000); }
  };
  const doCopy = () => { navigator.clipboard.writeText(link); setCopied(true); toast.success("Link copiato"); setTimeout(() => setCopied(false), 2000); };

  const input = "w-full border border-gray-200 rounded-xl px-4 py-3 mt-1 focus:border-violet-500 outline-none";

  if (result) {
    return (
      <Page>
        <div className="text-center pt-6" data-testid="referral-result">
          <div className="w-16 h-16 rounded-full bg-violet-100 flex items-center justify-center mx-auto mb-4"><Gift className="text-violet-700" size={28} /></div>
          <h1 className="serif text-2xl">Il tuo invito è pronto</h1>
          <p className="text-sm text-gray-500 mt-2">Premio: <b>{result.reward}</b>. Il buono matura quando la persona invitata completa {result.program === "trico" ? "il trattamento" : "una giornata coworking pagata"}.</p>
        </div>
        <div className="card p-4 mt-6">
          <div className="text-xs text-gray-400 mb-1">Il tuo link</div>
          <div className="text-sm break-all text-violet-700" data-testid="referral-link">{link}</div>
          <div className="text-xs text-gray-400 mt-2">Codice: <b>{result.code}</b></div>
        </div>
        <div className="flex gap-2 mt-4">
          <button data-testid="referral-share" onClick={doShare} className="btn-primary flex-1 inline-flex items-center justify-center gap-2"><Share2 size={16} />Condividi</button>
          <button data-testid="referral-copy" onClick={doCopy} className="btn-outline flex-1 inline-flex items-center justify-center gap-2">{copied ? <CheckCircle2 size={16} /> : <Copy size={16} />}Copia</button>
        </div>
        <button onClick={() => { setResult(null); setProgram(""); setF({ name: "", contact: "" }); }} className="text-sm text-gray-400 underline w-full text-center mt-6">Crea un altro invito</button>
      </Page>
    );
  }

  return (
    <Page>
      <SectionTitle sub="Aperto a chiunque. Invita un conoscente e ricevi un Buono Amazon quando l'invito si concretizza.">Invita e ricevi premi</SectionTitle>
      <form onSubmit={submit}>
        <div className="space-y-3 mb-5">
          {PROGRAMS.map((p) => (
            <button type="button" key={p.id} data-testid={`ref-program-${p.id}`} onClick={() => setProgram(p.id)}
              className={`w-full text-left card p-4 border ${program === p.id ? "border-violet-600 ring-1 ring-violet-200" : "border-gray-100"}`}>
              <div className="flex justify-between items-center">
                <div className="font-semibold">{p.title}</div>
                <span className="badge-chip state-DISPONIBILE">{p.reward}</span>
              </div>
              <p className="text-xs text-gray-500 mt-1">{p.desc}</p>
            </button>
          ))}
        </div>
        <label className="block text-sm">Il tuo nome
          <input data-testid="ref-name" className={input} value={f.name} onChange={set("name")} />
        </label>
        <label className="block text-sm mt-3">Telefono o email (per ricevere il premio)
          <input data-testid="ref-contact" className={input} value={f.contact} onChange={set("contact")} />
        </label>
        <button data-testid="ref-submit" disabled={busy} className="btn-primary w-full mt-5">{busy ? "Attendere…" : "Genera invito"}</button>
        <p className="text-[11px] text-gray-400 mt-4 leading-relaxed">Nessun premio in denaro. Il Buono Amazon viene consegnato manualmente da MAS dopo la conversione. Non serve inserire i dati dell'amico: condividi semplicemente il link.</p>
      </form>
    </Page>
  );
}
